import { createReducer, createSetter } from "@/redux/helpers/reducer";
import { STATUS } from "@/utils/constants";

import * as actions from "./payment-status.actions";

const initialState = {
  payments: [],
  invoiceTotal: "0.00",
  totalPaid: "0.00",
  balanceDue: "0.00",
  orderTotal: "0.00",
  orderOutstandingBalance: "0.00",
  fetchStatus: STATUS.IDLE,
  recordStatus: STATUS.IDLE,
  deleteStatus: STATUS.IDLE,
  restoreStatus: STATUS.IDLE,
  restoreError: null,
  deleteError: null,
  isRecordModalOpen: false,
  deleteTarget: null,
  paymentStatus: "Unpaid",
  paymentMethodOptions: [],
  paymentAccountOptions: [],
  partialInvoices: null,
};

export default createReducer(initialState, {
  [actions.setPayments]: createSetter("payments"),
  [actions.setInvoiceTotal]: createSetter("invoiceTotal"),
  [actions.setTotalPaid]: createSetter("totalPaid"),
  [actions.setBalanceDue]: createSetter("balanceDue"),
  [actions.setFetchStatus]: createSetter("fetchStatus"),
  [actions.setRecordStatus]: createSetter("recordStatus"),
  [actions.setDeleteStatus]: createSetter("deleteStatus"),
  [actions.setIsRecordModalOpen]: createSetter("isRecordModalOpen"),
  [actions.setDeleteTarget]: createSetter("deleteTarget"),
  [actions.setPaymentStatus]: createSetter("paymentStatus"),
  [actions.setPaymentMethodOptions]: createSetter("paymentMethodOptions"),
  [actions.setPaymentAccountOptions]: createSetter("paymentAccountOptions"),
  [actions.setPartialInvoices]: createSetter("partialInvoices"),
  [actions.setOrderTotal]: createSetter("orderTotal"),
  [actions.setOrderOutstandingBalance]: createSetter("orderOutstandingBalance"),
  [actions.setRestoreStatus]: createSetter("restoreStatus"),
  [actions.setRestoreError]: createSetter("restoreError"),
  [actions.setDeleteError]: createSetter("deleteError"),
  [actions.reset]: (state) => ({
    ...initialState,
    paymentMethodOptions: state.paymentMethodOptions,
    paymentAccountOptions: state.paymentAccountOptions,
  }),
});
